const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Access more than 35 tools premium features across the full suite including Enhancer, Remover, AI translater, Screen Recorder, and more, available at one, affordable price.',
  Upgrade: 'Upgrade',
  Tools: 'Werkzeuge',
  MyProjects: 'Meine Projekte',
  MyAccount: 'Mein Konto',
  Subscription: 'Abonnement',
  LogOut: 'Abmelden',
  PopularTools: 'Beliebte Tools',
  Enhance: 'Verbessern',
  Remove: 'Entfernen',
  Animate: 'Animieren',
  Extract: 'Extrahieren',
  SaveThreeDays:
    'Die Projekte werden 3 Tage lang gespeichert, bitte laden Sie sie nach der Bearbeitung herunter.',
  All: 'Alle',
  Video: 'Video',
  Image: 'Bild',
  Audio: 'Audio',
  minutesAgo: 'Vor Minuten',
  hoursAgo: 'Vor Stunden',
  daysAgo: 'Vor Tagen',
  Modified: 'Modifiziert',
  Order: 'Reihenfolge',
  EarliestToLatest: 'Vom Frühesten zum Spätesten',
  LatestToEarliest: 'Vom Spätesten zum Frühesten',
  NoProject: 'Noch kein Projekt. Schneller Einstieg mit',
  OnlineTools: 'Online-Tools',
  AIVideoEnhancer: 'AI Video Enhancer',
  Enhancer4K: 'Mit einem Klick bis zu 4K online KI-Videos verbessern',
  AIPhotoEnhancer: 'AI Photo Enhancer',
  AIEnhancerImage: 'AI enhance images losslessly up to 8X online',
  View: 'Anzeigen',
  Download: 'Herunterladen',
  MultipleSelect: 'Mehrfachauswahl',
  Delete: 'Löschen',
  SubscriptionHistory: 'Abonnement-Geschichte',
  NoValidSubscription: 'Kein gültiges Abonnement.',
  veContent: 'Ein Klick zur KI-Verbesserung von Videos auf bis zu 4K online',
  peContent: 'KI verbessert Bilder online verlustfrei um das bis zu 8-fache',
  rmvContent: 'Wasserzeichen aus Video entfernen',
  rmttContent: 'Entfernen Sie Wasserzeichen aus TikTok-Videos im Handumdrehen',
  dynamicContent: 'Animieren Sie Ihr Foto online',
  rmbgContent: 'Hintergrund vom Bild entfernen',
  youMayNeed: 'Du benötigst vielleicht',
  new: 'Neu',
  loginYourAccount: 'Loggen Sie sich in Ihr HitPaw-Konto ein',
  signUpYourAccount: 'Registrieren Sie sich für Ihr HitPaw-Konto',

  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
